export default __webpack_public_path__ + "static/logo_zh-Hant-9704781c0eeddded0a857b485055febb.png";